import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useClientCountry } from '../../hooks/useClientCountry';
import { appointmentBookingPathForCountry } from '../../config/api';
import { AppointmentsPage } from '../../features/booking/AppointmentsPage';

export const AppointmentsRouteIndex: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const { country } = useClientCountry();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate(appointmentBookingPathForCountry(country), { replace: true });
    }
  }, [isAuthenticated, country, navigate]);

  if (isAuthenticated) {
    return null;
  }

  return <AppointmentsPage />;
};
